import React from "react";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import MultiStep from "./../../editor/stepMenu";
import moment from "moment";
import styles from "./styles";
import SnackBar from "../../SnackBar";
const firebase = require("firebase");
require("firebase/firestore");

class Asignado extends React.Component {
  constructor() {
    super();
    this.state = {
      casos: null,
      selectedNoteIndex: null,
      selectedNote: null,
      datosAutoc: null,
      usuarios: null,
      name: "",
      guardado: false
    };
  }
  componentDidMount = () => {
    const user = firebase.auth().currentUser.displayName;
    firebase
      .firestore()
      .collection("notes")
      .orderBy("timestamp", "desc")
      .where("asignadoA", "==", user)
      .onSnapshot(serverUpdate => {
        const notes = serverUpdate.docs.map(_doc => {
          const data = _doc.data();
          data["id"] = _doc.id;
          data["name"] = user;
          return data;
        });
        this.setState({ casos: notes });
      });
    firebase
      .firestore()
      .collection("datosAutocompletado")
      .orderBy("text", "asc")
      .onSnapshot(serverUpdate => {
        const datosAutoc = serverUpdate.docs.map(_doc => {
          const data = _doc.data();
          data["id"] = _doc.id;
          return data;
        });
        this.setState({ datosAutoc });
      });

    firebase
      .firestore()
      .collection("usuarios")
      .orderBy("nombre", "asc")
      .onSnapshot(serverUpdate => {
        const usuarios = serverUpdate.docs.map(_doc => {
          const data = _doc.data();
          data["id"] = _doc.id;
          return data;
        });

        this.setState({ usuarios });
        //console.log(usuarios, "usuarios en el app antes del editor")
      });
  };
  selectNote = async (note, index) => {
    await this.setState({
      selectedNoteIndex: index,
      selectedNote: note
    });
  };
  handleClose = () => {
    this.setState({ guardado: !this.state.guardado });
  };
  handleClick = () => {
    this.setState({ guardado: !this.state.guardado });
  };
  noteUpdate = async (id, noteObj) => {
    await firebase
      .firestore()
      .collection("notes")
      .doc(id)
      .update({
        title: noteObj.title,
        body: noteObj.body,
        domicilio: noteObj.domicilio,
        telefono: noteObj.telefono,
        celular: noteObj.celular,
        email: noteObj.email,
        curp: noteObj.curp,
        rfc: noteObj.rfc,
        aseguradora: noteObj.aseguradora,
        ramo: noteObj.ramo,
        tiposeguro: noteObj.tiposeguro,
        asunto: noteObj.asunto,
        monto: noteObj.monto,
        descripcion: noteObj.descripcion,
        contrato: noteObj.contrato,
        honorarios: noteObj.honorarios,
        anticipo: noteObj.anticipo,
        asignadoA: noteObj.asignadoA,
        recomendado: noteObj.recomendado,
        estado: noteObj.estado,
        descr: noteObj.descr,
        actualizado: noteObj.actualizado,
        timestamp: firebase.firestore.FieldValue.serverTimestamp()
      });
    await firebase
      .firestore()
      .collection("notificaciones")
      .add({
        text: `${this.state.name} ha actualizado el caso #${noteObj.title}`,
        timestamp: firebase.firestore.FieldValue.serverTimestamp()
      })
      .then(doc => console.log("notificacion", doc));
    this.handleClick();
  };
  render() {
    const { classes } = this.props;
    return (
      <div>
        {!this.state.selectedNote ? (
          <div>
            <div>
              <Typography variant="h5" gutterBottom>
                Asignado
              </Typography>
            </div>
            <div>
              <List>
                <Card>
                  <ListItem alignItems="flex-start">
                    <div className={classes.textSection}>
                      <h4
                        className={classes.itemText}
                        style={{ width: "10%", textAlign: "center" }}
                      >
                        Numero
                      </h4>
                      <h4
                        className={classes.itemText}
                        style={{ width: "20%", textAlign: "center" }}
                      >
                        Cliente
                      </h4>
                      <h4
                        className={classes.itemText}
                        style={{ width: "14%", textAlign: "center" }}
                      >
                        Institucion
                      </h4>
                      <h4
                        className={classes.itemText}
                        style={{ width: "10%", textAlign: "center" }}
                      >
                        Asunto
                      </h4>
                      <h4
                        className={classes.itemText}
                        style={{ width: "10%", textAlign: "center" }}
                      >
                        Etapa
                      </h4>
                      <h4
                        className={classes.itemText}
                        style={{ width: "10%", textAlign: "center" }}
                      >
                        Actualizado
                      </h4>
                      <h4
                        className={classes.itemText}
                        style={{ width: "20%", textAlign: "center" }}
                      >
                        Descripcion
                      </h4>
                    </div>
                  </ListItem>
                </Card>
              </List>
              {this.state.casos ? (
                <List>
                  {this.state.casos.map((item, _index) => {
                    return (
                      <Card key={_index} className={classes.card}>
                        <ListItem alignItems="flex-start">
                          <div
                            onClick={() => this.selectNote(item, _index)}
                            className={classes.textSection}
                          >
                            <h4
                              className={classes.itemText2}
                              style={{ width: "10%", textAlign: "center" }}
                            >
                              {item.title}
                            </h4>
                            <h4
                              className={classes.itemText2}
                              style={{ width: "20%", textAlign: "center" }}
                            >
                              {item.body}
                            </h4>
                            <h4
                              className={classes.itemText2}
                              style={{ width: "14%", textAlign: "center" }}
                            >
                              {item.aseguradora}
                            </h4>
                            <h4
                              className={classes.itemText2}
                              style={{ width: "10%", textAlign: "center" }}
                            >
                              {item.asunto}
                            </h4>
                            <h4
                              className={classes.itemText2}
                              style={{ width: "10%", textAlign: "center" }}
                            >
                              {item.etapa}
                            </h4>
                            <h4
                              className={classes.itemText2}
                              style={{ width: "10%", textAlign: "center" }}
                            >
                              {item.timestamp
                                ? moment(item.timestamp.toDate()).format(
                                    "DD/MM/YYYY"
                                  )
                                : null}
                            </h4>
                            <h4
                              className={classes.itemText2}
                              style={{ width: "20%", textAlign: "center" }}
                            >
                              {item.descr}
                            </h4>
                          </div>
                        </ListItem>
                      </Card>
                    );
                  })}
                </List>
              ) : null}
            </div>
          </div>
        ) : (
          <>
            <Box
              component="span"
              m={0}
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end"
              }}
            >
              <Button
                style={{ margin: "6px" }}
                onClick={() =>
                  this.setState({ selectedNoteIndex: null, selectedNote: null })
                }
                variant="contained"
                color="primary"
              >
                Lista de Casos
              </Button>
            </Box>
            <MultiStep
              selectedNote={this.state.selectedNote}
              selectedNoteIndex={this.state.selectedNoteIndex}
              notes={this.state.casos}
              datosAutoc={this.state.datosAutoc}
              noteUpdate={this.noteUpdate}
              usuarios={this.state.usuarios}
            />
          </>
        )}
        {this.state.guardado && (
          <SnackBar
            open={this.state.guardado}
            handleClick={this.handleClick}
            handleClose={this.handleClose}
          />
        )}
      </div>
    );
  }
}

export default withStyles(styles)(Asignado);
